var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-date-container"},[(!_vm.hideInput)?_c('input',{class:_vm.cssClass,attrs:{"type":"text","id":_vm.id},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.onChange($event.target.value)},"blur":function($event){return _vm.onBlur($event.target.value)}}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }